import type { AcknowledgmentCommitmentItem } from '../model/types'
import { ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS as K } from '../translations'

export type OptionalToggle = {
  isOptional: boolean
  disabled: boolean
  reasonKey?: string
}

const hasSigner = (item: AcknowledgmentCommitmentItem) => Boolean(item.SignerEmail?.trim())

/**
 * Whether a signer can be switched between required and optional. A row with no signer has nothing to
 * switch, a signature already given is final, and each column keeps at least one required signer.
 */
export const getOptionalToggle = (
  item: AcknowledgmentCommitmentItem,
  columnItems: AcknowledgmentCommitmentItem[]
): OptionalToggle | null => {
  if (!hasSigner(item)) {
    return null
  }

  const isOptional = Boolean(item.IsOptional)
  const requiredCount = columnItems.filter((row) => hasSigner(row) && !row.IsOptional).length
  const isLastRequired = !isOptional && requiredCount <= 1

  return {
    isOptional,
    disabled: item.IsAcknowledged === 1 || isLastRequired,
    ...(isLastRequired ? { reasonKey: K.common.lastMandatoryReason } : {}),
  }
}
